import { memo } from "react";
import { isEqual } from "lodash";
import { Card, Empty, Typography } from "antd";
import { Bar } from "@ant-design/charts";
import { useQuery } from "@apollo/client";

import { SUBGRAPH_ORIGIN_METRICS_QUERY } from "../../helpers/graphql/subgraph";

const Metrics: React.FC<any> = memo(
  ({ data, max, height }) => {
    const config = {
      data,
      isStack: true,
      seriesField: "group",
      yField: "timestamp",
      yAxis: {
        tickCount: 24,
        label: {
          formatter: (v: string) => v.split(" ")[1],
        },
      },
      xField: "count",
      xAxis: {
        maxLimit: max,
      },
      tooltip: {
        formatter: ({ group, count }: any) => {
          return {
            name: group,
            value: Intl.NumberFormat("en-US", {
              notation: "compact",
              maximumFractionDigits: 1,
            }).format(count),
          };
        },
      },
    };
    return <Bar {...config} height={height} />;
  },
  (pre, next) => {
    return isEqual(pre?.data, next?.data);
  },
);

export function SubgraphOriginMetrics({ cluster, subgraphId, interval, showLast, height }: any) {
  const { loading, data } = useQuery(SUBGRAPH_ORIGIN_METRICS_QUERY, {
    variables: { cluster, subgraphId, interval, showLast },
  });

  const subgraphMetricsByOrigin =
    data?.subgraphMetricsByOrigin.length > 0
      ? data?.subgraphMetricsByOrigin
      : [
          {
            data: [],
            group: null,
          },
        ];

  let flattenArray: { group: string; timestamp: String; count: Number }[] = [];
  subgraphMetricsByOrigin.map((item: any) => {
    return item.data.map((point: any) => {
      return flattenArray.push({
        group: item.group,
        timestamp: new Date(point.timestamp)
          .toISOString()
          .replace("T", " ")
          .split(".")[0]
          .slice(0, -3),
        count: point.count,
      });
    });
  });
  flattenArray = flattenArray.sort((a: any, b: any) => a.timestamp.localeCompare(b.timestamp));

  return loading ? (
    <Card loading={true} className="card-loading" />
  ) : (
    <Card className={"card-body"} title="Request by origin">
      <Typography.Text style={{ color: "grey" }}></Typography.Text>

      {subgraphMetricsByOrigin && subgraphMetricsByOrigin.length > 0 ? (
        <Metrics
          data={flattenArray}
          max={flattenArray && flattenArray.length > 0 ? null : 4}
          height={height}
        />
      ) : (
        <Empty />
      )}
    </Card>
  );
}
